export default __webpack_public_path__ + "static/media/BuildingCredt.92b4b503.svg";